import { GiIceCube } from "react-icons/gi";
import CardLayout from "../common/CardLayout";
import TitleCard from "../common/TitleCard";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import Table from "../common/table";
import { useEffect, useState } from "react";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";
import { format } from "date-fns";
import { orderBy } from "../../funcs";
import apiMaquinaGelo from "../../services/apis/apiMaquinaGelo";
import StatusOnOff from "../common/StatusOnOff";

export default function MaquinasGelo() {

    const unidadeId = getCurrentUnidadeId();
    const [leituras, setLeituras] = useState([]);

    useEffect(() => {
        (async () => {
            const res = await apiMaquinaGelo.getByUnidadeId(unidadeId);
            const maquinasGelo = res.data;
            const leiturasMaquinasGelo = maquinasGelo.map((maquinaGelo) => ({...maquinaGelo.leiturasMaquinasGelo[0], nome: maquinaGelo.nome, maquinaGeloId: maquinaGelo.id}));
                        
            orderBy(leiturasMaquinasGelo, "maquinaGeloId");
            setLeituras(leiturasMaquinasGelo);
        })();
    },[unidadeId]);


    return <CardLayout>
    <Accordion
        type="single"
        defaultValue="item-1"
        collapsible="true"
    >
        <AccordionItem value="item-1">
            <div className="font-semibold">
                <AccordionTrigger>
                    <TitleCard>
                        Máquinas de Gelo
                        <p className="text-lg lg:text-4xl px-2">
                            <GiIceCube />
                        </p>
                    </TitleCard>
                </AccordionTrigger>
            </div>
            <AccordionContent>
                <div className="w-full">
                        <Table.Root>
                            <Table.Head>
                                {/* <Table.Header>
                                    <p className="font-bold">
                                        . . .
                                    </p>
                                </Table.Header> */}
                                <Table.Header>
                                    Máquina de Gelo id
                                </Table.Header>
                                <Table.Header>
                                    Nome
                                </Table.Header>
                                <Table.Header>
                                    Data Hora
                                </Table.Header>
                                <Table.Header>
                                    Status
                                </Table.Header>
                            </Table.Head>
                            <Table.Body>
                                {leituras?.map(
                                    (
                                        leitura
                                    ) => (
                                        <Table.Row
                                            key={
                                                leitura.id
                                            }
                                        >
                                            <Table.Data>
                                                {
                                                    leitura.maquinaGeloId
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    leitura.nome
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss") === "01/01/0001 00:00:00" ? "Sem leitura" : format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss")
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                <StatusOnOff status={leitura.ligado} />
                                            </Table.Data>
                                        </Table.Row>
                                    )
                                )}
                            </Table.Body>
                        </Table.Root>
                </div>
            </AccordionContent>
        </AccordionItem>
    </Accordion>
</CardLayout>
}